export interface BlogMeta {
  image: string;
  id: string;
  title: string;
  description: string;
}

// Using public folder paths to match existing project structure
// If images are imported (like in reference files), change to import statements
const blogMeta: BlogMeta[] = [
  {
    image: '/assets/images/09_BlogsDashboard/Frame 8.png',
    id: 'blog-1',
    title: 'Transforming Your Home with Timeless Interior Design',
    description: 'Creating a home that feels stylish, comfortable, and enduring is the goal of timeless interior design. Trends come and go, but a well-designed space grounded in classic principles will always feel fresh and inviting.',
  },
  {
    image: '/assets/images/09_BlogsDashboard/2.jpg',
    id: 'blog-2',
    title: 'The Power of Color in Interior Design',
    description: 'Color is one of the most powerful tools in interior design. Learn how color affects mood, creates cohesive palettes, and transforms your home.',
  },  
  {
    image: '/assets/images/Blog/meta/2.jpg',
    id: 'blog-3',
    title: 'Why Hiring an Interior Designer Is a Smart Investment',
    description: 'Hiring an interior designer is not just about aesthetics—its about making smart decisions that save time, money, and stress. Learn what an interior designer brings to your project.',
  },  
];

export default blogMeta;

